"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _excluded = ["context"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var debug = require('debug');
var nodeFetch = require("../client/fetch");
var isStream = require('is-stream');
var isBuffer = require('is-buffer');
var _require = require("./utils"),
  waitExponentialBackoff = _require.waitExponentialBackoff;
var defaultLogger = {
  info: debug('exchange:fetch'),
  error: debug('exchange:fetch:error'),
  warn: debug('exchange:fetch:warn')
};
var defaultEmptyBodyHeaders = {
  accept: 'application/json',
  'user-agent': 'Anypoint Fetch'
};
var defaultNonEmptyBodyHeaders = _objectSpread({
  'content-type': 'application/json'
}, defaultEmptyBodyHeaders);
var defaultContextMapping = {
  userAgent: 'user-agent',
  fromService: 'x-from-service',
  fromServiceVersion: 'x-from-service-version',
  ip: 'x-forwarded-for',
  id: 'x-request-id',
  authorization: 'authorization'
};
var ISTIO_ERRORS = [503, 504];
var ERROR_CODES = ['ECONNREFUSED', 'ECONNRESET', 'ETIMEDOUT', 'EADDRINFO', 'ESOCKETTIMEDOUT', 'EAI_AGAIN', 'ENOTFOUND'];
var INFO_CLIENT_ERROR_CODES = [400, 401, 403, 404, 409];
module.exports = fetchFactory;
module.exports.defaultHeaders = defaultNonEmptyBodyHeaders;
module.exports.contextMapping = defaultContextMapping;
var defaultErrorFactory = function defaultErrorFactory(response) {
  var error = new Error(response.statusText);
  error.details = {
    url: response.url
  };
  error.status = response.status;
  error.statusCode = response.status;
  return error;
};
var defaultErrorMessageFormatter = function defaultErrorMessageFormatter(error) {
  return error.message;
};
function fetchFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$logger = _ref.logger,
    logger = _ref$logger === void 0 ? defaultLogger : _ref$logger,
    _ref$defaultHeaders = _ref.defaultHeaders,
    defaultHeaders = _ref$defaultHeaders === void 0 ? defaultEmptyBodyHeaders : _ref$defaultHeaders,
    _ref$contextMapping = _ref.contextMapping,
    contextMapping = _ref$contextMapping === void 0 ? defaultContextMapping : _ref$contextMapping,
    _ref$errorFactory = _ref.errorFactory,
    errorFactory = _ref$errorFactory === void 0 ? defaultErrorFactory : _ref$errorFactory,
    _ref$errorMessageForm = _ref.errorMessageFormatter,
    errorMessageFormatter = _ref$errorMessageForm === void 0 ? defaultErrorMessageFormatter : _ref$errorMessageForm;
  return fetch;
  function getLoggingLevel(response) {
    if (INFO_CLIENT_ERROR_CODES.includes(response.status)) {
      return 'info';
    }
    if (response.status >= 400 && response.status < 500) {
      return 'warn';
    }
    return 'error';
  }
  function checkStatus(_ref2) {
    var response = _ref2.response,
      requestContext = _ref2.requestContext;
    var rateLimit = cleanEmptyProps({
      rateLimitLimit: getRateLimitLimit(response),
      rateLimitRemaining: getRateLimitRemaining(response),
      rateLimitReset: getRateLimitReset(response),
      rateLimitBy: getRateLimitBy(response),
      rateLimitKey: getRateLimitKey(response)
    });
    if (config.ignoreHTTPErrors || response.status >= 200 && response.status < 400) {
      logger.info(_objectSpread(_objectSpread({}, requestContext), {}, {
        message: 'Response',
        statusCode: response.status
      }, rateLimit));
      return response;
    }
    var requestId = response.headers.get('x-request-id') || requestContext.requestId;
    var contentType = response.headers.get('content-type');
    var error = errorFactory(response);
    error.getHeaders = function () {
      var headers = {};
      // Convert the headers Map to an Object
      response.headers.forEach(function (value, key) {
        headers[key] = value;
      });
      return headers;
    };
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return response.json().catch(function ($error) {
        logger.error({
          message: $error.message,
          requestId: requestId
        });
        throw $error;
      }).then(function (json) {
        var message = (json === null || json === void 0 ? void 0 : json.message) || error.message || 'No message';
        var loggingLevel = getLoggingLevel(response);
        logger[loggingLevel](_objectSpread(_objectSpread({}, requestContext), {}, {
          message: "Request returned an error: ".concat(message),
          statusCode: response.status,
          requestId: requestId
        }, rateLimit));
        if (config.preserveBodyOnErrors) {
          throw Object.assign(error, {
            json: json,
            requestId: requestId,
            statusCode: error.statusCode
          });
        }
        throw Object.assign(error, json, {
          requestId: requestId,
          statusCode: error.statusCode
        });
      });
    }
    return response.text().catch(function ($error) {
      logger.error({
        message: $error.message,
        requestId: requestId
      });
      throw $error;
    }).then(function (text) {
      var loggingLevel = getLoggingLevel(response);
      logger[loggingLevel](_objectSpread(_objectSpread({}, requestContext), {}, {
        message: "Request returned an error: ".concat(text),
        statusCode: response.status,
        requestId: requestId
      }, rateLimit));
      throw Object.assign(error, {
        message: text || error.message,
        requestId: requestId
      });
    });
  }
  function lowercaseProps(obj) {
    return Object.keys(obj).reduce(function (result, key) {
      // eslint-disable-next-line no-param-reassign
      result[key.toLowerCase()] = obj[key];
      return result;
    }, {});
  }
  function cleanEmptyProps(obj) {
    return Object.keys(obj).reduce(function (result, key) {
      if (obj[key] !== undefined && obj[key] !== null) {
        // eslint-disable-next-line no-param-reassign
        result[key] = obj[key];
      }
      return result;
    }, {});
  }

  /**
   * Fetch a URL with given data, checks for the response status.
   * Note: Sets accept and content-type headers to application/json by default.
   *
   * @param data {Object} Contains: context, headers, http method (optional, defaults to GET)
   * @returns {Promise}
   */
  function fetch(url) {
    var _context$userProfile, _context$sessionInfo, _context$sessionInfo2;
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      context = _ref3.context,
      data = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
    if ((config.ignoreContextValidation === undefined || config.ignoreContextValidation) && !context) {
      // eslint-disable-next-line no-param-reassign
      context = {};
    }
    if (!context) {
      return Promise.reject(new Error("context is required for API call ".concat(url)));
    }
    var userId = ((_context$userProfile = context.userProfile) === null || _context$userProfile === void 0 ? void 0 : _context$userProfile.id) || ((_context$sessionInfo = context.sessionInfo) === null || _context$sessionInfo === void 0 ? void 0 : _context$sessionInfo.user_id) || ((_context$sessionInfo2 = context.sessionInfo) === null || _context$sessionInfo2 === void 0 ? void 0 : _context$sessionInfo2.client_id);
    var requestContext = {
      userId: userId,
      requestId: context.id || context.requestId,
      spanId: context.spanId,
      traceId: context.traceId,
      method: data.method || 'GET',
      requestURI: url,
      requestUri: url // for backwards compatibility
    };
    logger.info(_objectSpread({
      message: 'Request'
    }, requestContext));
    var requestData = _objectSpread({}, data);
    if (!requestData.headers) {
      requestData.headers = {};
    } else {
      requestData.headers = lowercaseProps(requestData.headers);
    }
    if (!requestData.headers['user-agent'] && config.userAgent) {
      requestData.headers['user-agent'] = config.userAgent;
    }
    if (!Object.hasOwn(requestData, 'timeout') && Object.hasOwn(config, 'timeout')) {
      requestData.timeout = config.timeout;
    }
    Object.keys(contextMapping).forEach(function (key) {
      var header = contextMapping[key];
      var hasHeader = Object.hasOwn(requestData.headers, header);
      if (config.doNotForwardIp && header === 'x-forwarded-for') {
        // set to true to not forward ip to CS https://github.com/mulesoft/exchange-xapi/pull/624
        return;
      }
      if (!hasHeader && context[key]) {
        requestData.headers[header] = context[key];
      }
    });

    // Copy request Id to CS bullet tracing
    if (requestData.headers['x-request-id']) {
      requestData.headers['x-anypnt-trx-id'] = requestData.headers['x-request-id'];
    }
    if (config.credentials && !requestData.credentials) {
      requestData.credentials = config.credentials;
    }
    var defaultBodyHeaders = getDefaultHeadersForBody(requestData.body);
    Object.keys(defaultBodyHeaders).forEach(function (header) {
      var hasHeader = Object.hasOwn(requestData.headers, header);
      if (!hasHeader) {
        requestData.headers[header] = defaultBodyHeaders[header];
      }
    });
    requestData.headers = cleanEmptyProps(requestData.headers);
    if (requestData.body && requestData.headers['content-type'] && requestData.headers['content-type'].indexOf('application/json') !== -1 && (0, _typeof2.default)(requestData.body) === 'object' && !isStream(requestData.body) && !isBuffer(requestData.body)) {
      try {
        requestData.body = JSON.stringify(requestData.body);
      } catch (error) {
        return Promise.reject(new Error('Error when parsing the body'));
      }
    }
    return fetchWithRetries(url, requestData, requestContext, data.retries, data.waitSlotTime);
  }
  function fetchWithRetries(url, requestData, requestContext) {
    var maxRetries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var waitSlotTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 500;
    var attemptNumber = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var startTime = Date.now();
    var endTime;
    var isStreamBody = isStream(requestData.body);
    var responsePromise = nodeFetch(url, requestData);
    return responsePromise.catch(function (error) {
      endTime = Date.now();
      logger.error(_objectSpread(_objectSpread({
        message: "Fetch failed: ".concat(error.message)
      }, requestContext), {}, {
        attemptNumber: attemptNumber + 1,
        durationInMs: endTime - startTime
      }));
      throw Object.assign(error, {
        message: errorMessageFormatter(error)
      });
    }).then(function (response) {
      endTime = Date.now();
      return checkStatus({
        endTime: endTime,
        response: response,
        requestContext: _objectSpread(_objectSpread({}, requestContext), {}, {
          attemptNumber: attemptNumber + 1,
          durationInMs: endTime - startTime
        })
      });
    }).catch(/*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(error) {
        var retryCount;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!shouldRetry({
                error: error,
                attemptNumber: attemptNumber,
                maxRetries: maxRetries,
                durationInMs: endTime - startTime,
                isStreamBody: isStreamBody
              })) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return waitExponentialBackoff(waitSlotTime, attemptNumber);
            case 3:
              retryCount = attemptNumber + 1;
              logger.info(_objectSpread({
                message: "Request Retry #".concat(retryCount)
              }, requestContext));
              return _context.abrupt("return", fetchWithRetries(url, requestData, requestContext, maxRetries, waitSlotTime, retryCount));
            case 6:
              if (error.type === 'request-timeout') {
                error.status = 504; // eslint-disable-line no-param-reassign
              }
              throw error;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
  }

  /**
   * Determine if a request should be retried.
   * (Borrowed from superagent)
   *
   * @param {Error} error
   * @param {Number} retries
   * @returns {Boolean}
   */
  function shouldRetry(_ref5) {
    var error = _ref5.error,
      attemptNumber = _ref5.attemptNumber,
      maxRetries = _ref5.maxRetries,
      durationInMs = _ref5.durationInMs,
      isStreamBody = _ref5.isStreamBody;
    if (typeof maxRetries === 'number' && attemptNumber < maxRetries) {
      if (error.status && error.status >= 500 && error.status !== 501) {
        return true;
      }
      if (error.code && ERROR_CODES.includes(error.code)) {
        return true;
      }
    }
    var isIstioError = error.status && ISTIO_ERRORS.includes(error.status);
    var isInIstioTimeWindow = config.istioRetryTimeout && durationInMs < config.istioRetryTimeout;
    return !!(isInIstioTimeWindow && !isStreamBody && attemptNumber < (config.istioMaxRetries || 0) && isIstioError);
  }
  function getHeader(object, header) {
    return object.headers.get(header);
  }
  function getRateLimitLimit(res) {
    return getHeader(res, 'x-ratelimit-limit');
  }
  function getRateLimitRemaining(res) {
    return getHeader(res, 'x-ratelimit-remaining');
  }
  function getRateLimitReset(res) {
    return getHeader(res, 'x-ratelimit-reset');
  }
  function getRateLimitBy(res) {
    return getHeader(res, 'x-ratelimit-by');
  }
  function getRateLimitKey(res) {
    return getHeader(res, 'x-ratelimit-key');
  }
  function getDefaultHeadersForBody(body) {
    if (body) {
      return defaultNonEmptyBodyHeaders;
    }
    return defaultHeaders;
  }
}
//# sourceMappingURL=index.js.map